import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p485848922662797312',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
